// Sommaire des pages légales Shopify Policies — wrapper fin autour du
// module générique clebs-toc.js. Le markup .shopify-policy__* est natif
// Shopify (absent des fichiers du thème) : on ne touche jamais à
// .shopify-policy__body, qui reste la zone éditable depuis Settings > Policies.
(() => {
  const layout = document.querySelector('.shopify-policy__container');
  const title = document.querySelector('.shopify-policy__title');
  const content = document.querySelector('.shopify-policy__body');
  if (!layout || !title || !content) return;

  window.ClebsToc.build({ layout, title, content });
})();
